module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-vest.ef55e6b8.svg";